import moment from 'moment'
import { get } from 'lodash'

export default subscription => {
  const start = get(subscription, 'periodStart', 0)
  const end = get(subscription, 'periodEnd', 0)
  return {
    start: moment.unix(start).startOf('minute'),
    end: moment.unix(end).startOf('minute')
  }
}
